<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crt"><a class="page" id="piv"></a>NEW YORK UNIVERSITY PRESS</p>
<p class="crt">New York</p>
<p class="crt"><a class="url" href="http://www.nyupress.org" target="_blank">www.nyupress.org</a></p>
<p class="crt">© 2018 by New York University</p>
<p class="crt">All rights reserved</p>
<p class="crtf">An earlier draft of chapter 2 was previously published in <i>American Studies</i> 52, no. 2 (2013): 23–42, University of Kansas; reprinted by permission. An abbreviated version of chapter 3 appears in <i>Shopping for Change: Consumer Activism and the Possibilities of Purchasing Power</i>, ed. Joseph Tohill and Louis Hyman (Toronto: Between the Lines; Ithaca, NY: Cornell University Press / ILR Press, 2017), 221–229; reprinted by permission.</p>
<p class="crtf">References to Internet websites (URLs) were accurate at the time of writing. Neither the author nor New York University Press is responsible for URLs that may have expired or changed since the manuscript was prepared.</p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cip">Names: Barrett, Dawson, author.</p>
<p class="cip">Title: The defiant : protest movements in post-liberal America / Dawson Barrett.</p>
<p class="cip">Description: New York : New York University Press, 2018. | Includes bibliographical references and index.</p>
<p class="cip">Identifiers: LCCN 2017044873 | ISBN 9781479808656 (cloth : alk. paper)</p>
<p class="cip">Subjects: LCSH: Protest movements—United States—History. | United States—Social conditions—1980– | Social justice—United States—History.</p>
<p class="cip">Classification: LCC HN59.2 .B36 2018 | DDC 303.48/40973—dc23</p>
<p class="cip">LC record available at <a class="url" href="https://lccn.loc.gov/2017044873" target="_blank">https://lccn.loc.gov/2017044873</a></p>
<p class="crtf">New York University Press books are printed on acid-free paper, and their binding materials are chosen for strength and durability. We strive to use environmentally responsible suppliers and materials to the greatest extent possible in publishing our books.</p>
<p class="crt">Manufactured in the United States of America</p>
<p class="crt">10 9 8 7 6 5 4 3 2 1</p>
<p class="crt">Also available as an ebook</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// barretthedefiant-0004.vue?076426b3